<template>
  <v-card elevation="0" color="grey lighten-4" class="mb-8">
    <v-card-text class="pb-0">
      <v-row>
        <v-col>
          <v-menu
            ref="datepicker"
            :close-on-content-click="false"
            v-model="datepicker"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :rules="[validDate]"
                v-model="departureDate"
                label="Avgångsdatum"
                readonly
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              locale="sv"
              first-day-of-week="1"
              v-model="departureDate"
              @input="datepicker = false"
              no-title
            />
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            label="Tågnummer"
            outlined
            type="number"
            @keydown.enter.stop.prevent="onSearchTrain"
            v-model.number="model.train_number"
            :rules="[required]"
          />
        </v-col>
        <v-col cols="auto">
          <v-btn
            x-large
            :loading="$apollo.loading"
            color="grey lighten-2"
            @click="onSearchTrain"
          >
            <v-icon>mdi-magnify</v-icon> Sök
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { validDate } from '@/common/validationRules'
import { format, startOfDay } from 'date-fns'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import gql from 'graphql-tag'

export default {
  name: 'TrainDeviationActivitySearch',

  props: {
    editMode: Boolean
  },

  data: () => ({
    validDate,
    required,
    datepicker: false,
    initEdit: false,
    departureDate: format(new Date(), 'yyyy-MM-dd')
  }),

  computed: {
    model: sync('trainDeviation/model')
  },

  mounted() {
    if (this.editMode) {
      this.departureDate = format(new Date(this.model.departure), 'yyyy-MM-dd')
    }
  },

  apollo: {
    searchTrain: {
      query: gql`
        query searchTrain($filter: SearchTrainInput!) {
          searchTrain(filter: $filter) {
            public_number
            places {
              type
              location
              location_long_name
              advertised
              delay_minutes
            }
          }
        }
      `,
      skip() {
        return true
      },
      variables() {
        return {
          filter: {
            train_number: this.model.train_number || null,
            date: this.departureDate
          }
        }
      }
    }
  },

  methods: {
    onSearchTrain() {
      this.$apollo.queries.searchTrain.skip = false
    }
  },

  watch: {
    departureDate() {
      console.log('tes')
      this.$store.set(
        'trainDeviation/model@departure',
        startOfDay(new Date(this.departureDate))
      )
      this.$store.set(
        'trainDeviation/model@arrival',
        startOfDay(new Date(this.departureDate))
      )
      this.$store.set(
        'trainDeviation/model@departure_date',
        format(new Date(this.departureDate), 'yyyy-MM-dd')
      )

      if (this.editMode) {
        if (this.initEdit) {
          this.onSearchTrain()
        }
      } else {
        this.onSearchTrain()
      }

      this.initEdit = true
    },
    searchTrain: {
      handler(value) {
        if (this.$apollo.queries.searchTrain) {
          this.$apollo.queries.searchTrain.skip = true
        }

        if (!value) {
          this.$store.set('trainDeviation/places', [])
          this.$store.set('trainDeviation/model@type', 'TJT')
          this.$store.set('trainDeviation/model@to', null)
          this.$store.set('trainDeviation/model@from', null)
          this.$store.set(
            'trainDeviation/model@departure',
            startOfDay(new Date(this.departureDate))
          )
          this.$store.set(
            'trainDeviation/model@arrival',
            startOfDay(new Date(this.departureDate))
          )
          this.$store.set(
            'trainDeviation/model@departure_date',
            format(new Date(this.departureDate), 'yyyy-MM-dd')
          )
          return
        }

        this.$store.set(
          'trainDeviation/model@train_number',
          value.public_number
        )
        this.$store.set('trainDeviation/places', value.places)

        this.$store.set('trainDeviation/model@type', 'RST')

        const departurePlaces = this.$store.get(
          'trainDeviation/departurePlaces'
        )
        const arrivalPlaces = this.$store.get('trainDeviation/arrivalPlaces')
        const arrivalPlace = arrivalPlaces[arrivalPlaces.length - 1]
        const departurePlace = departurePlaces[0]

        this.$store.set(
          'trainDeviation/model@to',
          `${arrivalPlace.short_name}_${arrivalPlace.advertised}`
        )

        this.$store.set(
          'trainDeviation/model@from',
          `${departurePlace.short_name}_${departurePlace.advertised}`
        )
        this.$store.set(
          'trainDeviation/model@departure_date',
          format(new Date(this.departureDate), 'yyyy-MM-dd')
        )
      }
    }
  }
}
</script>
